var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 22",
    fill: "none",
    stroke: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.262 8.402.009.001c.267.04.354.35.174.524v.001l-4.834 4.513-.006.005-.006.007c-.29.289-.468.693-.387 1.153l1.06 6.53a.309.309 0 0 1-.452.324h-.001l-5.821-3.133a1.286 1.286 0 0 0-1.203-.008l-.005.002-5.895 3.034a.306.306 0 0 1-.442-.327v-.007l.173-1.008 1.011-5.5a1.274 1.274 0 0 0-.36-1.16h-.001L.589 8.69c-.165-.165-.09-.466.186-.508l6.56-.888.01-.002.012-.002c.404-.073.771-.306.974-.711v-.001L11.314.665a.319.319 0 0 1 .564.012l2.854 5.954c.181.433.569.662.96.733l.012.002 5.967.937h.004l.588.099Z"
  })));
};

export default SvgStar;